import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "children", "className", "size", "fontWeight", "fontFamily"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Text from '../../Text';
import styles from './index.module.css';

const PrimaryLabel = /*#__PURE__*/function () {
  const PrimaryLabel = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var _classnames;

    var as = _ref.as,
        children = _ref.children,
        className = _ref.className,
        size = _ref.size,
        fontWeight = _ref.fontWeight,
        fontFamily = _ref.fontFamily,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    var classnames = (_classnames = {}, _classnames[styles.root] = true, _classnames);
    return /*#__PURE__*/React.createElement(Text, _extends({}, rest, {
      as: as,
      className: cx(classnames, className),
      ref: ref,
      size: size,
      fontWeight: fontWeight,
      fontFamily: fontFamily
    }), children);
  });
  PrimaryLabel.displayName = 'PrimaryLabel';
  PrimaryLabel.identifier = PrimaryLabel.displayName; // used in docs website

  PrimaryLabel.defaultProps = {
    as: 'div',
    fontWeight: 'medium',
    size: 'Heading6',
    fontFamily: 'system'
  };
  return PrimaryLabel;
}();

export default PrimaryLabel;